import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import { isMobile } from "../../../../helpers";

class Logout extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.props.dispatch(actions.auth.logout());

    }

    render() {

        return (
            <div></div>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Logout);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account/Logout.js